module.exports = "<article class=\"media\" (click)=\"navigateToActivity()\">\n  <figure class=\"media-left\">\n    <p class=\"image is-48x48\">\n      <img [src]=\"sender.avatarUrl\">\n    </p>\n  </figure>\n  <div class=\"media-content\">\n    <div class=\"content\">\n      <p>\n        <strong>{{sender.displayName}}</strong>\n        <span [innerHtml]=\"getMessage()\"></span>\n      </p>\n    </div>\n  </div>\n</article>\n"


//////////////////
// WEBPACK FOOTER
// /mnt/d/Projects/angular/chisparural-foro/src/app/activity/notification-item/notification-item.component.html
// module id = ../../../../../src/app/activity/notification-item/notification-item.component.html
// module chunks = 1